import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface BreadcrumbItem {
  label: string;
  link: string;
}

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private titleSubject = new BehaviorSubject<string>('Dashboard');
  private breadcrumbBaseSubject = new BehaviorSubject<BreadcrumbItem[]>([]);
  private breadcrumbSuffixSubject = new BehaviorSubject<BreadcrumbItem[]>([]);

  get title$(): Observable<string> {
    return this.titleSubject.asObservable();
  }

  /** Breadcrumb = base (from my-modules on navigation) + suffix (e.g. "إنشاء" set by component). */
  get breadcrumb$(): Observable<BreadcrumbItem[]> {
    return combineLatest([
      this.breadcrumbBaseSubject.asObservable(),
      this.breadcrumbSuffixSubject.asObservable()
    ]).pipe(
      map(([base, suffix]) => [...(base ?? []), ...(suffix ?? [])])
    );
  }

  setTitle(title: string): void {
    const base = this.breadcrumbBaseSubject.getValue() ?? [];
    const suffix = this.breadcrumbSuffixSubject.getValue() ?? [];

    const breadcrumb = [...base, ...suffix];

    const lastItem = breadcrumb[breadcrumb.length - 1];

    if (lastItem) {
      this.titleSubject.next(lastItem.label); // أو name حسب الموديل عندك
    }
  }

  /**
   * Legacy: components used to pass Home > module > page. Base is always from my-modules via setBreadcrumbBase;
   * only items beyond the first three are kept as suffix (e.g. create / edit).
   */
  setBreadcrumb(breadcrumb: Array<BreadcrumbItem>): void {
    /*
    const items = breadcrumb ?? [];
    if (items.length > 3) {
      this.breadcrumbSuffixSubject.next(items.slice(3));
    } else {
      this.breadcrumbSuffixSubject.next([]);
    }
      */
  }

  /** Set by layout on NavigationEnd from my-modules. Clears suffix. */
  setBreadcrumbBase(breadcrumb: Array<BreadcrumbItem>): void {
    this.breadcrumbBaseSubject.next(breadcrumb ?? []);
    this.breadcrumbSuffixSubject.next([]);
  }

  /** Updates base only (keeps suffix). Used after child init so create/edit crumbs are not wiped. */
  patchBreadcrumbBase(breadcrumb: Array<BreadcrumbItem>): void {
    this.breadcrumbBaseSubject.next(breadcrumb ?? []);
  }

  /** Append one or more levels (e.g. "إنشاء" / "تعديل"). Does not clear base. */
  setBreadcrumbSuffix(suffix: Array<BreadcrumbItem>): void {
    this.breadcrumbSuffixSubject.next(suffix ?? []);
  }

  /** Used by layout to avoid overwriting form-specific titles after suffix is set. */
  getBreadcrumbSuffixSnapshot(): BreadcrumbItem[] {
    return this.breadcrumbSuffixSubject.getValue() ?? [];
  }

  constructor() { }
}
